






















import Vue from "vue";
export default Vue.extend({
  name: "MessageModal",
  props: {
    important:
    {
      type: String,
      default: ""
    } ,
    header: {
      type: String,
      default: "Information"
    },
    "button-text-yes": {
      type: String,
      default: "Ja"
    },
    "button-text-no": {
      type: String,
      default: "Nej"
    },
    confirmData: {
      type: String,
      default: ""
    }

  },
  methods: {
    close: function(): void {
      this.$emit("close");
    },
    confirm: function(choice: boolean): void {
      this.$emit("confirm", {choice:choice, data:this.confirmData});
    }
  }
});
